<template>
  <div class="container py-10">
    <div v-if="computedSubmissionDetails" class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Applicant Details</h2>
        <div v-if="computedApplicantInfo" class="mb-3">
          <d-field label="First Name">
            <d-input v-model="computedApplicantInfo.firstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedApplicantInfo.lastName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedApplicantInfo.email" />
          </d-field>
          <d-field label="Job Title">
            <d-input v-model="computedApplicantInfo.jobTitle" />
          </d-field>
          <d-field label="Phone #">
            <d-input v-model="computedApplicantInfo.phone" />
          </d-field>
          <d-field label="Fax #">
            <d-input v-model="computedApplicantInfo.fax" />
          </d-field>
        </div>
        <d-field label="Address Line 1">
          <d-input v-model="computedSubmissionDetails.revisedApplicantAddressLine1" />
        </d-field>
        <d-field label="Address Line 2">
          <d-input v-model="computedSubmissionDetails.revisedApplicantAddressLine2" />
        </d-field>
        <d-field label="City">
          <d-input v-model="computedSubmissionDetails.revisedApplicantCity" />
        </d-field>
        <d-field label="State/Province">
          <d-input v-model="computedSubmissionDetails.revisedApplicantState" />
        </d-field>
        <d-field label="Zip/Postal">
          <d-input v-model="computedSubmissionDetails.revisedApplicantZip" />
        </d-field>
        <d-field label="Country">
          <d-input v-model="computedSubmissionDetails.revisedApplicantCountry" />
        </d-field>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Applicant Details</h2>
        <d-field label="Drafting Experience">
          <d-input v-model="computedSubmissionDetails.revisedDraftingExperience" type="textarea" />
        </d-field>
        <d-field label="AWI Standards">
          <div>
            <div>
              <d-checkbox v-model="computedAwiStandards" native-value="I currently own a copy of the AWI Architectural Woodwork Standards, 2nd Edition">
                I own a copy of the current AWI Standards
              </d-checkbox>
            </div>
            <div>
              <d-checkbox v-model="computedAwiStandards" native-value="I am currently an active AWI Member">
                I am currently an active AWI Member
              </d-checkbox>
            </div>
            <div>
              <d-checkbox v-model="computedAwiStandards" native-value="Please send me AWI Membership information">
                Please send me AWI Membership information
              </d-checkbox>
            </div>
          </div>
        </d-field>
        <d-field label="How did you hear about the QCP IDA program?">
          <d-input v-model="computedSubmissionDetails.revisedHowDidYouHearAboutProgram" />
        </d-field>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Transaction Information</h2>
        <d-field label="Amount">
          <d-input v-model="computedAmount" type="number" />
        </d-field>
        <d-field label="Billing Company Name">
          <d-input v-model="computedTransactionDetails.companyName" />
        </d-field>
        <d-field label="Billing Address Line 1">
          <d-input v-model="computedTransactionDetails.billingAddress1" />
        </d-field>
        <d-field label="Billing Address Line 2">
          <d-input v-model="computedTransactionDetails.billingAddress2" />
        </d-field>
        <d-field label="Billing City">
          <d-input v-model="computedTransactionDetails.billingCity" />
        </d-field>
        <d-field label="Billing State/Province">
          <d-input v-model="computedTransactionDetails.billingStateProvince" />
        </d-field>
        <d-field label="Billing Zip">
          <d-input v-model="computedTransactionDetails.billingZip" />
        </d-field>
        <d-field label="Billing Email">
          <d-input v-model="computedTransactionDetails.billingEmail" type="email" />
        </d-field>
        <d-field label="Billing Phone">
          <d-input v-model="computedTransactionDetails.billingPhone" />
        </d-field>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Professional Reference #1</h2>
        <div v-if="computedReference1Info" class="mb-3">
          <d-field label="First Name">
            <d-input v-model="computedReference1Info.firstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedReference1Info.lastName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedReference1Info.email" />
          </d-field>
          <d-field label="Job Title">
            <d-input v-model="computedReference1Info.jobTitle" />
          </d-field>
          <d-field label="Phone #">
            <d-input v-model="computedReference1Info.phone" />
          </d-field>
          <d-field label="Fax #">
            <d-input v-model="computedReference1Info.fax" />
          </d-field>
        </div>
        <d-field label="Address Line 1">
          <d-input v-model="computedSubmissionDetails.revisedReference1AddressLine1" />
        </d-field>
        <d-field label="Address Line 2">
          <d-input v-model="computedSubmissionDetails.revisedReference1AddressLine2" />
        </d-field>
        <d-field label="City">
          <d-input v-model="computedSubmissionDetails.revisedReference1City" />
        </d-field>
        <d-field label="State/Province">
          <d-input v-model="computedSubmissionDetails.revisedReference1State" />
        </d-field>
        <d-field label="Zip/Postal">
          <d-input v-model="computedSubmissionDetails.revisedReference1Zip" />
        </d-field>
        <d-field label="Country">
          <d-input v-model="computedSubmissionDetails.revisedReference1Country" />
        </d-field>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Professional Reference #2</h2>
        <div v-if="computedReference2Info" class="mb-3">
          <d-field label="First Name">
            <d-input v-model="computedReference2Info.firstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedReference2Info.lastName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedReference2Info.email" />
          </d-field>
          <d-field label="Job Title">
            <d-input v-model="computedReference2Info.jobTitle" />
          </d-field>
          <d-field label="Phone #">
            <d-input v-model="computedReference2Info.phone" />
          </d-field>
          <d-field label="Fax #">
            <d-input v-model="computedReference2Info.fax" />
          </d-field>
        </div>
        <d-field label="Address Line 1">
          <d-input v-model="computedSubmissionDetails.revisedReference2AddressLine1" />
        </d-field>
        <d-field label="Address Line 2">
          <d-input v-model="computedSubmissionDetails.revisedReference2AddressLine2" />
        </d-field>
        <d-field label="City">
          <d-input v-model="computedSubmissionDetails.revisedReference2City" />
        </d-field>
        <d-field label="State/Province">
          <d-input v-model="computedSubmissionDetails.revisedReference2State" />
        </d-field>
        <d-field label="Zip/Postal">
          <d-input v-model="computedSubmissionDetails.revisedReference2Zip" />
        </d-field>
        <d-field label="Country">
          <d-input v-model="computedSubmissionDetails.revisedReference2Country" />
        </d-field>
      </div>

      <div v-if="computedTransactionInfo" class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Billing Information</h2>
        <div class="mb-3">
          <d-field label="First Name">
            <d-input v-model="computedTransactionInfo.billingFirstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedTransactionInfo.billingLastName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedTransactionInfo.billingEmail" />
          </d-field>
          <d-field label="Phone #">
            <d-input v-model="computedTransactionInfo.billingPhone" />
          </d-field>
          <d-field label="Address 1">
            <d-input v-model="computedTransactionInfo.billingAddress1" />
          </d-field>
          <d-field label="Address 2">
            <d-input v-model="computedTransactionInfo.billingAddress2" />
          </d-field>
          <d-field label="City">
            <d-input v-model="computedTransactionInfo.billingCity" />
          </d-field>
          <d-field label="State/Province">
            <d-input v-model="computedTransactionInfo.billingStateProvince" />
          </d-field>
          <d-field label="Zip/Postal">
            <d-input v-model="computedTransactionInfo.billingZip" />
          </d-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },

      transactionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedTransactionDetails: {
        get() {
          return this.transactionDetails;
        },
        set(value) {
          this.$emit('update:transactionDetails', value);
        },
      },

      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('update:submissionDetails', value);
        },
      },

      computedAmount: {
        get() {
          return this.computedTransactionDetails.amount;
        },
        set(value) {
          this.computedTransactionDetails.amount = Number.parseInt(value, 10);
        },
      },

      computedApplicantInfo() {
        return this.computedSubmissionDetails.revisedApplicant;
      },

      computedReference1Info() {
        return this.computedSubmissionDetails.revisedReference1;
      },

      computedReference2Info() {
        return this.computedSubmissionDetails.revisedReference2;
      },

      computedTransactionInfo() {
        return this.computedSubmissionDetails.transaction;
      },

      computedAwiStandards: {
        get() {
          return JSON.parse(this.computedSubmissionDetails.revisedAWIStandards);
        },
        set(value) {
          this.computedSubmissionDetails.revisedAWIStandards = JSON.stringify(value);
        },
      },
    },
  };
</script>